import React from 'react';
import { useTranslation } from 'react-i18next';

const DeliveryPerformance = ({ data }) => {
    const { t } = useTranslation();
    if (!data) return null;

    const strings = t('deliveryAnalytics.charts.performance', { returnObjects: true });

    const deliveryRate = parseFloat(data.delivery_rate || 0).toFixed(1);
    const total = data.total_orders || 0;

    const statuses = [
        { label: strings.delivered, value: data.delivered_orders ?? 0, color: '#10b981', bg: '#f0fdf4' },
        { label: strings.inTransit, value: data.in_transit_orders ?? 0, color: '#3b82f6', bg: '#eff6ff' },
        { label: strings.pending,   value: data.pending_orders ?? 0,   color: '#f59e0b', bg: '#fffbeb' },
    ];

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.title}</span>
                    <div style={subtitleStyle}>{strings.subtitle}</div>
                </div>
            </div>

            {/* Big delivery rate */}
            <div style={{ padding: '20px 20px 8px', display: 'flex', alignItems: 'flex-end', gap: 12 }}>
                <div style={{ fontSize: 52, fontWeight: 900, color: '#10b981', lineHeight: 1 }}>
                    {deliveryRate}%
                </div>
                <div style={{ paddingBottom: 6 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>{strings.deliveryRate}</div>
                    <div style={{ fontSize: 11, color: '#9ca3af' }}>{total} {strings.totalOrdersSuffix}</div>
                </div>
            </div>

            {/* Stacked bar */}
            {total > 0 && (
                <div style={{ padding: '0 20px 16px' }}>
                    <div style={{ display: 'flex', height: 8, borderRadius: 8, overflow: 'hidden', gap: 1 }}>
                        {statuses.filter(s => s.value > 0).map(s => (
                            <div key={s.label} title={`${s.label}: ${s.value}`}
                                style={{ flex: s.value, backgroundColor: s.color, minWidth: 2 }} />
                        ))}
                    </div>
                </div>
            )}

            {/* Status rows */}
            <div style={{ padding: '4px 20px 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                {statuses.map(s => {
                    const pct = total > 0 ? ((s.value / total) * 100).toFixed(1) : 0;
                    return (
                        <div key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 12px', borderRadius: 8, backgroundColor: '#f9fafb' }}>
                            <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: s.color, flexShrink: 0 }} />
                            <span style={{ fontSize: 13, color: '#374151', flex: 1, fontWeight: 500 }}>{s.label}</span>
                            <span style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{s.value}</span>
                            <span style={{ fontSize: 11, fontWeight: 600, color: s.color, backgroundColor: `${s.color}20`, borderRadius: 12, padding: '2px 8px', minWidth: 44, textAlign: 'center' }}>
                                {pct}%
                            </span>
                        </div>
                    );
                })}
            </div>

            {/* Avg delivery days */}
            <div style={{ padding: '0 20px 20px' }}>
                <div style={{ backgroundColor: '#f9fafb', borderRadius: 10, padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 12, color: '#6b7280', fontWeight: 500 }}>{strings.avgDeliveryTime}</span>
                    <span style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>
                        {data.average_delivery_days ? `${parseFloat(data.average_delivery_days).toFixed(1)} ${strings.daysSuffix}` : t('common.symbols.emDash')}
                    </span>
                </div>
            </div>
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', height: '100%' };
const headerStyle = { padding: '18px 20px 8px', borderBottom: '1px solid #f9fafb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };

export default DeliveryPerformance;
